import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1ce8692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "who-am-i" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "who-am-i__description" }, "A hardworking 29-year-old Senior Software Developer, based in Whiteley, Hampshire, UK, who enjoys learning new skills and experiences. I have created websites using HTML, CSS, JavaScript (Vanilla & jQuery), PHP (Laravel), Ruby (Ruby on Rails), SQL, Git Version Control and NET. I also have experience in creating software packages with C#. I'm consistently looking for new projects and challenges to tackle, whether big or small.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.whoAmIImage,
      class: "who-am-i__image"
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}